import { render, staticRenderFns } from "./ConfirmationButton.vue?vue&type=template&id=35ee0b61&"
import script from "./ConfirmationButton.vue?vue&type=script&lang=js&"
export * from "./ConfirmationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports